var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"absolute"}},[(_vm.gameUrl)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.gameUrl,"width":"100%","height":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }